import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
// Redux
import { Provider } from 'react-redux'
import store from './agrifresh/store'

const root = ReactDOM.createRoot(document.getElementById('agrifresh-root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
)

reportWebVitals()
